import { render, staticRenderFns } from "./CustomFieldsManager.vue?vue&type=template&id=4618bc14&scoped=true"
import script from "./CustomFieldsManager.vue?vue&type=script&lang=js"
export * from "./CustomFieldsManager.vue?vue&type=script&lang=js"
import style0 from "./CustomFieldsManager.vue?vue&type=style&index=0&id=4618bc14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4618bc14",
  null
  
)

export default component.exports